import axios from 'axios';
import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_RESET_TOKENS,
} from '@/store/actions/auth';
import { USER_REQUEST } from '@/store/actions/user';

const state = {
  accessToken: localStorage.getItem('access-token') || '',
  refreshToken: localStorage.getItem('refresh-token') || '',
  status: '',
  hasLoadedOnce: false,
};

/* eslint-disable no-shadow */
const getters = {
  isAuthenticated: state => !!state.accessToken,
  authStatus: state => state.status,
};
/* eslint-enable */

/* eslint-disable arrow-body-style */
const actions = {
  AUTH_REQUEST: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      axios({
        url: `${window.api_url}api/login`,
        data: {
          email: payload.email,
          password: payload.password,
        },
        method: 'POST',
      })
        .then((resp) => {
          localStorage.setItem('access-token', resp.data.access_token);
          localStorage.setItem('refresh-token', resp.data.refresh_token);
          window.axios.defaults.headers.common.Authorization = `Bearer ${resp.data.access_token}`;
          commit(AUTH_SUCCESS, resp);
          dispatch(USER_REQUEST);
          resolve(resp);
        })
        .catch((err) => {
          commit(AUTH_ERROR, err);
          localStorage.removeItem('access-token');
          localStorage.removeItem('refresh-token');
          payload.vm.$toasted.clear();
          payload.vm.$toasted.show(err.response.data.message, { duration: 3000, singleton: true, type: 'error' });
          reject(err);
        });
    });
  },
  AUTH_REGISTER: ({ commit }, registerDetails) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      axios({ url: `${window.api_url}api/register`, data: registerDetails, method: 'POST' })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  AUTH_LOGOUT: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT);
      axios({ url: `${window.api_url}api/logout`, method: 'POST' })
        .then(() => {
          localStorage.removeItem('access-token');
          localStorage.removeItem('refresh-token');
        })
        .catch((err) => {
          commit(AUTH_ERROR, err);
          localStorage.removeItem('access-token');
          localStorage.removeItem('refresh-token');
          reject(err);
        });
      resolve();
    });
  },
  AUTH_RESET_TOKENS: ({ commit }) => {
    localStorage.removeItem('access-token');
    localStorage.removeItem('refresh-token');
    commit(AUTH_RESET_TOKENS);
  },
};
/* eslint-enable */

/* eslint-disable no-shadow, no-param-reassign */
const mutations = {
  AUTH_REQUEST: (state) => {
    state.status = 'loading';
  },
  AUTH_SUCCESS: (state, resp) => {
    state.status = 'success';
    state.accessToken = resp.data.access_token;
    state.refreshToken = resp.data.refresh_token;
    state.hasLoadedOnce = true;
  },
  AUTH_ERROR: (state) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
  },
  AUTH_LOGOUT: (state) => {
    state.accessToken = '';
    state.refreshToken = '';
  },
  AUTH_RESET_TOKENS: (state) => {
    state.accessToken = '';
    state.refreshToken = '';
  },
};
/* eslint-enable */

export default {
  state,
  getters,
  actions,
  mutations,
};
